import { appEnvironment, chromeExtensionId } from 'helpers/constants';
import { AsyncStorage } from 'services';

export const isChrome = !!window.chrome;
export let isExtensionInstalled: boolean | null = null;

interface PingResponse {
  pong: boolean;
}

/**
 * Sends a message to chrome runtime to see if
 * the extension is installed. If the ping message
 * gets a response with "pong" it's because the extension is installed
 */
export function pingExtension() {
  if (appEnvironment === 'web' && window.chrome?.runtime?.sendMessage) {
    (chrome.runtime.sendMessage as any)(
      chromeExtensionId,
      { type: 'ping' },
      (response: PingResponse) => {
        isExtensionInstalled = !!response?.pong;
      }
    );
  }
}

export async function autoLoginExtension() {
  if (appEnvironment === 'web' && window.chrome?.runtime?.sendMessage) {
    (chrome.runtime.sendMessage as any)(
      chromeExtensionId,
      {
        type: 'autoLogin',
        refreshToken: await AsyncStorage.get('refreshToken'),
        accessToken: await AsyncStorage.get('accessToken'),
        organizationId: await AsyncStorage.get('organizationId'),
      },
      (response: any) => {
        console.log(response);
      }
    );
  }
}

pingExtension();
